import React from "react"
const VerifiedBadge = () => {
  return (
    <except-outlook>
      <div
        style={{
          display: "inline-block",
          paddingLeft: "4px",
          verticalAlign: "top",
          paddingBottom: 0
        }}
      >
        <img
          width="20"
          height="20"
          style={{ width: "20px", height: "20px" }}
          alt="Twitter Logo"
          src={`${process.env.NODE_FUNCTIONS_HOST}/icons?icon=check-circle&foreground=1d8ced&background=000000&shape=icon-only&v=3`}
        />
      </div>
    </except-outlook>
  )
}
export default VerifiedBadge
